/**
 * Strips HTML tags and checks if remaining content is only whitespace
 * For use with RichTextEditor where empty content includes HTML tags like <p>   </p>
 */
export const validateRichTextWhitespace = (value: string | null | undefined) => {
  if (!value) return true; // Let required rule handle empty values

  // Strip HTML tags and decode HTML entities
  const textContent = value
    .replace(/<[^>]*>/g, '') // Remove HTML tags
    .replace(/&nbsp;/g, ' ') // Replace &nbsp; with regular space
    .trim();

  return !!textContent || "Can't contain only whitespace";
};
